module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASBAMAAABCyVggAAAAAXNSR0IB2cksfwAAAA9QTFRFAAAAAAAAAAAAAAAAAAAATw7njQAAAAV0Uk5TABDP/9Addq/1AAAAN0lEQVR4nGNgYGBgVGJAACETBJtR2RFZQoACCQZnYzhQQOY4MIgYISljdFZEcgy5UkgcRhcoAwCt8Qo5TMNWXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/login-back-dark-icon.png
// module id = 860
// module chunks = 0